import React, { useEffect, useRef } from 'react';

export const Timer = ({ show, onCompletion }) => {
  const intervalRef = useRef(null);
  const timeRef = useRef(30); // Start with 30 seconds
  const onCompletionRef = useRef(onCompletion);

  // Update the callback ref whenever onCompletion changes
  useEffect(() => {
    onCompletionRef.current = onCompletion;
  }, [onCompletion]);

  useEffect(() => {
    if (show && !intervalRef.current) {
      // Initialize timer only if it's not already running
      timeRef.current = 30;
      
      const updateTimer = () => {
        const element = document.getElementById('timer');
        const seconds = timeRef.current;
        const displaySeconds = seconds < 10 ? `0${seconds}` : seconds;
        
        if (element) {
          element.innerHTML = `Time Remaining ${displaySeconds} seconds`;
        }

        if (seconds <= 0) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
          onCompletionRef.current();
          return;
        }

        timeRef.current--;
      };

      // Update immediately, then start interval
      updateTimer();
      intervalRef.current = setInterval(updateTimer, 1000);
    }

    if (!show && intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [show]); // Only depend on 'show'

  return show ? <div id="timer"></div> : null;
};